import l10n from '../../../shared/strings';
import { resolveChannelLabel, resolveChannelLabels } from './showPublishedToChannelToast';

export const showDraftForChannelToast = ({
  Toast,
  channelIds = [],
  salesChannels = [],
}) => {
  if (!channelIds.length) {
    return;
  }

  if (channelIds.length === 1) {
    const channelLabel = resolveChannelLabel(channelIds[0], salesChannels);
    Toast(l10n.TOAST.DRAFT_FOR_CHANNEL(channelLabel), { type: 'success' });
    return;
  }

  const channelLabels = resolveChannelLabels(channelIds, salesChannels);
  Toast(l10n.TOAST.DRAFT_FOR_CHANNELS(channelLabels), { type: 'success' });
};
